export class UploadEvent {
  public type: string;
  public message: string;
  public progressPercent: number;
  public callbackId?: string;

  constructor(type: string, message: string = null, callbackId?: string) {
    this.type = type;
    this.message = message;
    this.callbackId = callbackId;
  }
}
